import type { Event } from '@patsnap/tahiti-core';
import type { ParagraphIssueGroup } from '@/domains/proof-reading/types';

/**
 * 段落替换参数
 */
export interface ReplaceParagraphParams {
    /**
     * 段落问题组
     */
    issue: ParagraphIssueGroup;
    /**
     * 新的段落内容
     */
    content: string;
    /**
     * 任务ID
     */
    taskId: string;
}

/**
 * 段落替换成功事件
 */
export interface ParagraphReplacedEvent {
    /**
     * 段落问题组
     */
    issue: ParagraphIssueGroup;
    /**
     * 替换的内容
     */
    content: string;
    /**
     * 任务ID
     */
    taskId: string;
}

/**
 * 段落替换服务
 */
export interface ParagraphReplacementService {
    /**
     * 替换段落内容
     * @param params 替换参数
     * @returns Promise<void>
     */
    replaceParagraph(params: ReplaceParagraphParams): Promise<void>;

    /**
     * 段落替换成功事件
     */
    readonly onParagraphReplaced: Event<ParagraphReplacedEvent>;

    /**
     * 段落替换失败事件
     */
    readonly onParagraphReplaceFailed: Event<{
        params: ReplaceParagraphParams;
        error: Error;
    }>;
}

export const ParagraphReplacementService = Symbol.for('ParagraphReplacementService');
